// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-headline-1{font-size:56px;text-transform:uppercase}.text-headline-1,.text-headline-2{font-family:Helvetica;font-style:normal;font-weight:700;line-height:120%}.text-headline-2{font-size:48px}.text-headline-3{font-size:32px}.text-headline-3,.text-headline-4{font-family:Helvetica;font-style:normal;font-weight:700;line-height:130%}.text-headline-4{font-size:24px}.text-headline-5{font-family:Helvetica;font-style:normal;font-weight:700;font-size:18px;line-height:130%}.text-body-xlarge{font-weight:400}.text-body-xlarge,.text-body-xlarge-bold{font-family:Helvetica;font-style:normal;font-size:20px;line-height:150%}.text-body-xlarge-bold{font-weight:700}.text-body-large{font-weight:400}.text-body-large,.text-body-large-bold{font-family:Helvetica;font-style:normal;font-size:16px;line-height:150%}.text-body-large-bold{font-weight:700}.text-body-main{font-weight:400}.text-body-main,.text-body-main-bold{font-family:Helvetica;font-style:normal;font-size:14px;line-height:150%}.text-body-main-bold{font-weight:700}.text-body-little{font-weight:400}.text-body-little,.text-body-little-bold{font-family:Helvetica;font-style:normal;font-size:11px;line-height:150%}.text-body-little-bold{font-weight:700}.text-body-small{font-weight:400}.text-body-small,.text-body-small-bold{font-family:Helvetica;font-style:normal;font-size:12px;line-height:150%}.text-body-small-bold{font-weight:700}.text-body-tiny{font-weight:400}.text-body-tiny,.text-body-tiny-bold{font-family:Helvetica;font-style:normal;font-size:10px;line-height:150%}.text-body-tiny-bold{font-weight:700}.text-link-1{color:#40a8af}.text-link-1,.text-link-2{font-family:Helvetica;font-style:normal;font-weight:400;font-size:14px;line-height:150%;-webkit-text-decoration-line:underline;text-decoration-line:underline}.text-link-2{color:#008b95}.text-link-3{font-size:14px;-webkit-text-decoration-line:underline;text-decoration-line:underline;color:#077077}.text-footer-link,.text-link-3{font-family:Helvetica;font-style:normal;font-weight:400;line-height:150%}.text-footer-link{font-size:10px;color:#80898e}.text-button{font-family:Helvetica;font-style:normal;font-weight:700;font-size:14px;line-height:150%;text-transform:none!important}@font-face{font-family:helvetica;src:url(/design-system/dist/assets/variables/typography/fonts/helvetica/Helvetica.woff2) format(\"woff2\")}@font-face{font-family:HelveticaNeue;src:url(/design-system/dist/assets/variables/typography/fonts/helvetica-neue/HelveticaNeue.woff2) format(\"woff2\")}.sideBarStyle{margin-left:50px}.noSideBarStyle{padding-top:0!important}", ""]);
// Exports
exports.locals = {
	"color_primary_400": "#0b6267",
	"color_primary_500": "#0f5458",
	"color_primary_800": "#16393a",
	"color_primary_900": "#0f1c1d",
	"color_secondary_100": "#dff0f2",
	"color_secondary_200": "#bfe2e4",
	"color_secondary_300": "#9fd3d7",
	"color_secondary_400": "#80c5ca",
	"color_secondary_500": "#60b6bd",
	"color_accent_100": "#40a629",
	"color_accent_200": "#159477",
	"color_accent_300": "#dfdf00",
	"color_accent_400": "#aac811",
	"color_accent_500": "#f5a800",
	"color_accent_600": "#d29b00",
	"color_accent_700": "#f6f7fb",
	"color_button_links_300": "#40a8af",
	"color_button_links_400": "#008b95",
	"color_button_links_500": "#077077",
	"color_button_links_opacity_300": "rgba(64,168,175,.2)",
	"color_button_links_opacity_400": "rgba(64,168,175,.5)",
	"color_button_links_opacity_500": "rgba(7,112,119,.5)",
	"color_grey_100": "#fff",
	"color_grey_200": "#ebeaeb",
	"color_grey_300": "#e2e2e2",
	"color_grey_400": "#d1d0d1",
	"color_grey_500": "#b3b6b8",
	"color_grey_600": "#949b9e",
	"color_grey_700": "#80898e",
	"color_grey_800": "#5b6063",
	"color_grey_900": "#000",
	"color_white_opacity_100": "hsla(0,0%,100%,.1)",
	"color_white_opacity_500": "hsla(0,0%,100%,.5)",
	"color_white_opacity_800": "hsla(0,0%,100%,.8)",
	"color_white": "#fff",
	"color_black_opacity_100": "rgba(0,0,0,.05)",
	"color_black_opacity_200": "rgba(0,0,0,.15)",
	"color_black_opacity_400": "rgba(0,0,0,.4)",
	"color_black_opacity_800": "rgba(0,0,0,.8)",
	"color_black": "#000",
	"color_splines_100": "#2b9e84",
	"color_splines_200": "#1f7e84",
	"color_splines_300": "#8d3b77",
	"color_splines_400": "#604d77",
	"color_alert_success_500": "#2b9d54",
	"color_alert_success_opacity_500": "rgba(43,157,84,.5)",
	"color_alert_warning_500": "#ffdc00",
	"color_alert_warning_600": "#fabe00",
	"color_alert_warning_opacity_500": "rgba(255,220,0,.5)",
	"color_alert_urgent_500": "#ff4600",
	"color_alert_urgent_opacity_500": "rgba(255,70,0,.5)",
	"color_alert_info_500": "#3cb6bd",
	"color_alert_info_opacity_500": "rgba(60,182,189,.5)"
};
module.exports = exports;
